import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { PrivacyComponent } from './auth/privacy/privacy.component';
import { TermsComponent } from './auth/terms/terms.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { ResetRequestComponent} from './admin/reset-request/reset-request.component';

import { LayoutComponent } from "./layout/layout.component";
import { AssignedComponent } from './layout/assigned/assigned.component';
import { AssignedDetailsComponent } from './layout/assigned-details/assigned-details.component';
import { AssignedDetailsMoudleComponent } from './layout/assigned-details-moudle/assigned-details-moudle.component';
import { AssignedResumeComponent } from './layout/assigned-resume/assigned-resume.component';
import { AssignedAttemptComponent } from './layout/assigned-attempt/assigned-attempt.component';
import { AssignedDetailsResumeComponent } from './layout/assigned-details-resume/assigned-details-resume.component';
import { AssignedContactAdministratorComponent } from './layout/assigned-contact-administrator/assigned-contact-administrator.component';
import { AssignedResetRequestComponent } from './layout/assigned-reset-request/assigned-reset-request.component';


import { CompletedComponent } from './layout/completed/completed.component';
import { CompletedDetailsComponent } from './layout/completed-details/completed-details.component';

import { ViewerComponent } from './layout/viewer/viewer.component';
import { ViewerDetailsComponent } from './layout/viewer-details/viewer-details.component';
import { ViewerQuestionComponent } from './layout/viewer-question/viewer-question.component';
import { ViewerQuestionLastComponent } from './layout/viewer-question-last/viewer-question-last.component';

import { SubmodulePassedComponent } from './layout/submodule-passed/submodule-passed.component';
import { ModulePassedComponent } from './layout/module-passed/module-passed.component';
import { ModuleFailedComponent } from './layout/module-failed/module-failed.component';
import { ContactAdminComponent } from './layout/contact-admin/contact-admin.component';

import { ChangepasswordComponent } from './layout/changepassword/changepassword.component';
///// ADMIN 
import { ChangepasswordAdminComponent } from './admin/changepassword-admin/changepassword-admin.component';
import { AdminComponent } from "./admin/admin.component";
import { UserComponent } from "./admin/user/user.component";
import { UserCreateComponent } from "./admin/user-create/user-create.component";
import { UserEditComponent } from "./admin/user-edit/user-edit.component";
import { UserSuccessfullyComponent } from "./admin/user-successfully/user-successfully.component";
import { ContentAuthSuccessComponent } from "./admin/content-auth-success/content-auth-success.component";

import { ViewCoursesComponent } from "./admin/view-courses/view-courses.component";
import { AssignCoursesComponent } from "./admin/assign-courses/assign-courses.component";
import { UserDeactiveComponent } from "./admin/user-deactive/user-deactive.component";
import { OrganisationComponent } from "./admin/organisation/organisation.component";
import { OrganisationCreateComponent } from "./admin/organisation-create/organisation-create.component";
import { CourseComponent } from "./admin/course/course.component";
import { CourseDetailsComponent } from "./admin/course-details/course-details.component";
import { CourseViewUserComponent } from "./admin/course-view-user/course-view-user.component";
import { CourseViewCourseComponent } from "./admin/course-view-course/course-view-course.component";
import { CourseCreateComponent } from "./admin/course-create/course-create.component";
import { CourseAddModulesComponent } from "./admin/course-add-modules/course-add-modules.component";
import { CourseAddReviewComponent } from "./admin/course-add-review/course-add-review.component";
import { CourseAddAssignUserComponent } from "./admin/course-add-assign-user/course-add-assign-user.component";
import { CoursesAssignUsersComponent } from "./admin/courses-assign-users/courses-assign-users.component";
import { CourseContentCapsuleComponent } from "./admin/course-content-capsule/course-content-capsule.component";
import { CourseAssignAfterPublishComponent } from "./admin/course-assign-after-publish/course-assign-after-publish.component";
import { CoursePublishComponent } from "./admin/course-publish/course-publish.component";
import { AddModuleAssessmentComponent } from "./admin/add-module-assessment/add-module-assessment.component";
import { AddAuthoringAssessmentComponent } from "./admin/add-authoring-assessment/add-authoring-assessment.component";
import { AuthoringCreateComponent } from "./admin/authoring-create/authoring-create.component";
import { AuthoringListComponent } from "./admin/authoring-list/authoring-list.component";
import { AuthoringViewComponent } from "./admin/authoring-view/authoring-view.component";
import { AuthoringAssessmentViewComponent } from "./admin/authoring-assessment-view/authoring-assessment-view.component";
import { CourseAssessmentViewComponent } from "./admin/course-assessment-view/course-assessment-view.component";
import { AuthoringActivatedCourseComponent } from "./admin/authoring-activated-course/authoring-activated-course.component";
import { AuthoringDeactivatedCourseComponent } from "./admin/authoring-deactivated-course/authoring-deactivated-course.component";
import { AuthoringViewContentComponent } from "./admin/authoring-view-content/authoring-view-content.component";
import { ResetComponent } from "./admin/reset/reset.component";
import { CreatePasswordComponent } from './auth/create-password/create-password.component';
import { AuthGuard } from './guard/auth.guard';
import { OrganizationSuccessfullyComponent } from './admin/organization-successfully/organization-successfully.component';
import { SuperAdminComponent } from './admin/super-admin/super-admin.component';
import { SuperAdminCreateComponent } from './admin/super-admin-create/super-admin-create.component';
import { SuperAdminEditComponent } from './admin/super-admin-edit/super-admin-edit.component';
import { AdminForgotPasswordComponent } from './admin/admin-forgot-password/admin-forgot-password.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { SettingComponent } from './admin/setting/setting.component';
import { UserContactUsComponent } from './layout/user-contact-us/user-contact-us.component';
import { ManageTicketsComponent } from './admin/manage-tickets/manage-tickets.component';
import { TicketDetailComponent } from './admin/ticket-detail/ticket-detail.component';
import { AssessmentsComponent } from './layout/assessments/assessments.component';
import { CourseLibraryComponent } from './layout/course-library/course-library.component';
import { ManageAssessmentsComponent } from './admin/manage-assessments/manage-assessments.component';
import { CreateAssessmentComponent } from './admin/create-assessment/create-assessment.component';
import { ViewAssessmentComponent } from './admin/view-assessment/view-assessment.component';
import { AssessmentAssignUsersComponent } from './admin/assessment-assign-users/assessment-assign-users.component';
import { AssessmentViewUserComponent } from './admin/assessment-view-user/assessment-view-user.component';
import { ViewerAssessmentComponent } from './layout/viewer-assessment/viewer-assessment.component';


const routes: Routes = [
  {
    path: "",
    component: LoginComponent,
    data: { title: "rail e-learning | Login" }
  },{
   path: "admin-login",
   component: AdminLoginComponent,
   data: { title: "rail e-learning | Admin Login" }
    
  },{
    path: "change_password",
    component: LayoutComponent,
    children: [
      { path: "", component: ChangepasswordComponent, data: { title: "rail e-learning | Change Password" } }
    ],
    data: { title: "rail e-learning | Change Password" }
  },{
    path: "create_password",
    component: CreatePasswordComponent,
    data: { title: "rail e-learning | Create Password" }
  },{
    path: "forgot",
    component: ForgetPasswordComponent,
    data: { title: "rail e-learning | Forgot" }
  },{
    path: "contact_us",
    component: ContactUsComponent,
    data: { title: "rail e-learning | Contact" }
  },{
    path: "terms",
    component: TermsComponent,
    data: { title: "rail e-learning | Contact" }
  },{
    path: "privacy",
    component: PrivacyComponent,
    data: { title: "rail e-learning | Privacy" }
  },{
    canActivate:[AuthGuard],
    path: "assigned",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedComponent, data: { title: "rail e-learning | Assigned" } }
    ],
    data: { title: "rail e-learning | Assigned" }
  },{
    path: "assigned_details",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedDetailsComponent, data: { title: "rail e-learning | Assigned Details" } }
    ],
    data: { title: "rail e-learning | Assigned" }
  },{
    path: "assigned_details_moudle",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedDetailsMoudleComponent, data: { title: "rail e-learning | Assigned Details" } }
    ],
    data: { title: "rail e-learning | Assigned" }
  },{
    path: "assigned_resume",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedResumeComponent, data: { title: "rail e-learning | Assigned Resume" } }
    ],
    data: { title: "rail e-learning | Assigned Resume" }
  },{
    path: "assigned_attempt",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedAttemptComponent, data: { title: "rail e-learning | Assigned Attempt" } }
    ],
    data: { title: "rail e-learning | Assigned Attempt" }
  },{
    path: "assigned_details_resume",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedDetailsResumeComponent, data: { title: "rail e-learning | Assigned Attempt" } }
    ],
    data: { title: "rail e-learning | Assigned Attempt" }
  },{
    path: "assigned_contact_administrator",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedContactAdministratorComponent, data: { title: "rail e-learning | Assigned Contact Admin" } }
    ],
    data: { title: "rail e-learning | Assigned Contact Admin" }
  },{
    path: "assigned_reset_request",
    component: LayoutComponent,
    children: [
      { path: "", component: AssignedResetRequestComponent, data: { title: "rail e-learning | Assigned Reset Request" } }
    ],
    data: { title: "rail e-learning | Assigned Reset Request" }
  },{
    path: "completed",
    component: LayoutComponent,
    children: [
      { path: "", component: CompletedComponent, data: { title: "rail e-learning | Completed" } }
    ],
    data: { title: "rail e-learning | Completed" }
  },{
    path: "completed_details",
    component: LayoutComponent,
    children: [
      { path: "", component: CompletedDetailsComponent, data: { title: "rail e-learning | Completed Details" } }
    ],
    data: { title: "rail e-learning | Completed Details" }
  },{
    path: "viewer",
    component: LayoutComponent,
    children: [
      { path: "", component: ViewerComponent, data: { title: "rail e-learning | viewer" } }
    ],
    data: { title: "rail e-learning | viewer" }
  },
  {
    path: "viewer-details",
    component: LayoutComponent,
    children: [
      { path: "", component: ViewerDetailsComponent, data: { title: "rail e-learning | viewer details" } }
    ],
    data: { title: "rail e-learning | viewer" }
  },{
    path: "viewer_question",
    component: LayoutComponent,
    children: [
      { path: "", component: ViewerQuestionComponent, data: { title: "rail e-learning | Question" } }
    ],
    data: { title: "rail e-learning | Question" }
  },{
    path: "viewer_question_last",
    component: LayoutComponent,
    children: [
      { path: "", component: ViewerQuestionLastComponent, data: { title: "rail e-learning | Question Last" } }
    ],
    data: { title: "rail e-learning | Question Last" }
  },{
    path: "Submodule_Passed",
    component: LayoutComponent,
    children: [
      { path: "", component: SubmodulePassedComponent, data: { title: "rail e-learning | Submodule Passed" } }
    ],
    data: { title: "rail e-learning | Submodule Passed" }
  },{
    path: "module_Passed",
    component: LayoutComponent,
    children: [
      { path: "", component: ModulePassedComponent, data: { title: "rail e-learning | Module Passed" } }
    ],
    data: { title: "rail e-learning | Module Passed" }
  },{
    path: "module_failed",
    component: LayoutComponent,
    children: [
      { path: "", component: ModuleFailedComponent, data: { title: "rail e-learning | Module Failed" } }
    ],
    data: { title: "rail e-learning | Module Failed" }
  },{
    path: "contact_admin",
    component: LayoutComponent,
    children: [
      { path: "", component: ContactAdminComponent, data: { title: "rail e-learning | Contact Admin" } }
    ],
    data: { title: "rail e-learning | Contact Admin" }
  },
  {
    path: "contact-us",
    component: LayoutComponent,
    children: [
      { path: "", component: UserContactUsComponent, data: { title: "rail e-learning | Contact Us" } }
    ],
    data: { title: "rail e-learning | Assigned" }
  },
  {
    path: "assessments",
    component: LayoutComponent,
    children: [
      { path: "", component: AssessmentsComponent, data: { title: "rail e-learning | Assessments" } }
    ],
    data: { title: "rail e-learning | Assessments" }
  },
  {
    path: "course-library",
    component: LayoutComponent,
    children: [
      { path: "", component: CourseLibraryComponent, data: { title: "rail e-learning | Course Library" } }
    ],
    data: { title: "rail e-learning | Course Library" }
  },
  {
    path: "user",
    component: AdminComponent,
    children: [
      { path: "", component: UserComponent, data: { title: "rail e-learning Admin | User" } }
    ],
    data: { title: "rail e-learning Admin | User" }
  },{
    path: "reset_request",
    component: AdminComponent,
    children: [
      { path: "", component: ResetRequestComponent, data: { title: "rail e-learning Admin | Reset Request" } }
    ],
    data: { title: "rail e-learning Admin | Reset Request" }
  },{
    path: "user_create",
    component: AdminComponent,
    children: [
      { path: "", component: UserCreateComponent, data: { title: "rail e-learning Admin | User Create" } }
    ],
    data: { title: "rail e-learning Admin | User Create" }
  },{
    path: "admin_changepassword",
    component: AdminComponent,
    children: [
      { path: "", component: ChangepasswordAdminComponent, data: { title: "rail e-learning Admin | change  password" } }
    ],
    data: { title: "rail e-learning Admin | User Create" }
  },{
    path: "user_edit",
    component: AdminComponent,
    children: [
      { path: "", component: UserEditComponent, data: { title: "rail e-learning Admin | User Edit" } }
    ],
    data: { title: "rail e-learning Admin | User Edit" }
  },{
    path: "user_deactive",
    component: AdminComponent,
    children: [
      { path: "", component: UserDeactiveComponent, data: { title: "rail e-learning Admin |  User Deactive" } }
    ],
    data: { title: "rail e-learning Admin |  User Deactive" }
  },{
    path: "user_successfully",
    component: AdminComponent,
    children: [
      { path: "", component: UserSuccessfullyComponent, data: { title: "rail e-learning Admin | User Successfully" } }
    ],
    data: { title: "rail e-learning Admin | User Successfully" }
  },{
    path: "content-auth-success",
    component: AdminComponent,
    children: [
      { path: "", component: ContentAuthSuccessComponent, data: { title: "rail e-learning Admin | Content Auth Successfully" } }
    ],
    data: { title: "rail e-learning Admin | User Successfully" }
  },{
    path: "view_courses",
    component: AdminComponent,
    children: [
      { path: "", component: ViewCoursesComponent, data: { title: "rail e-learning Admin | View Courses" } }
    ],
    data: { title: "rail e-learning Admin | View Courses" }
  },{
    path: "assign_courses",
    component: AdminComponent,
    children: [
      { path: "", component: AssignCoursesComponent, data: { title: "rail e-learning Admin | Assign Courses" } }
    ],
    data: { title: "rail e-learning Admin | Assign Courses" }
  },{
    path: "organisation",
    component: AdminComponent,
    children: [
      { path: "", component: OrganisationComponent, data: { title: "rail e-learning Admin | Organisation Management" } }
    ],
    data: { title: "rail e-learning Admin | Organisation Management" }
  },{
    path: "organisation_create",
    component: AdminComponent,
    children: [
      { path: "", component: OrganisationCreateComponent, data: { title: "rail e-learning Admin | Organisation Create" } }
    ],
    data: { title: "rail e-learning Admin | Organisation Create" }
  },{
    path: "courses",
    component: AdminComponent,
    children: [
      { path: "", component: CourseComponent, data: { title: "rail e-learning Admin | Courses" } }
    ],
    data: { title: "rail e-learning Admin | Courses" }
  },{
    path: "courses_details",
    component: AdminComponent,
    children: [
      { path: "", component: CourseDetailsComponent, data: { title: "rail e-learning Admin | Courses Details" } }
    ],
    data: { title: "rail e-learning Admin | Courses Details" }
  },{
    path: "courses_assign_users",
    component: AdminComponent,
    children: [
      { path: "", component: CoursesAssignUsersComponent, data: { title: "rail e-learning Admin | Courses Assign Users" } }
    ],
    data: { title: "rail e-learning Admin | Courses Assign Users" }
  },{
    path: "courses_view_user",
    component: AdminComponent,
    children: [
      { path: "", component: CourseViewUserComponent, data: { title: "rail e-learning Admin | Courses View Users" } }
    ],
    data: { title: "rail e-learning Admin | Courses View Users" }
  },{
    path: "courses_view_courses",
    component: AdminComponent,
    children: [
      { path: "", component: CourseViewCourseComponent, data: { title: "rail e-learning Admin | Courses View Courses" } }
    ],
    data: { title: "rail e-learning Admin | Courses View Courses" }
  },{
    path: "courses_create",
    component: AdminComponent,
    children: [
      { path: "", component: CourseCreateComponent, data: { title: "rail e-learning Admin | Courses Create" } }
    ],
    data: { title: "rail e-learning Admin | Courses Create" }
  },{
    path: "courses_add_modules",
    component: AdminComponent,
    children: [
      { path: "", component: CourseAddModulesComponent, data: { title: "rail e-learning Admin | Courses Add Modules" } }
    ],
    data: { title: "rail e-learning Admin | Courses Create" }
  },{
    path: "courses_add_review",
    component: AdminComponent,
    children: [
      { path: "", component: CourseAddReviewComponent, data: { title: "rail e-learning Admin | Courses Review" } }
    ],
    data: { title: "rail e-learning Admin | Courses Review" }
  },{
    path: "courses_add_assign_user",
    component: AdminComponent,
    children: [
      { path: "", component: CourseAddAssignUserComponent, data: { title: "rail e-learning Admin | Courses Assign User" } }
    ],
    data: { title: "rail e-learning Admin | Courses Assign User" }
  },{
    path: "courses_content_capsule",
    component: AdminComponent,
    children: [
      { path: "", component: CourseContentCapsuleComponent, data: { title: "rail e-learning Admin | Courses Assign User" } }
    ],
    data: { title: "rail e-learning Admin | Courses Assign User" }
  },{
    path: "courses_published",
    component: AdminComponent,
    children: [
      { path: "", component: CoursePublishComponent, data: { title: "rail e-learning Admin | Courses published" } }
    ],
    data: { title: "rail e-learning Admin | Courses published" }
  },{
    path: "courses_assign_after_published",
    component: AdminComponent,
    children: [
      { path: "", component: CourseAssignAfterPublishComponent, data: { title: "rail e-learning Admin | Courses published" } }
    ],
    data: { title: "rail e-learning Admin | Courses published" }
  },{
    path: "add_Module",
    component: AdminComponent,
    children: [
      { path: "", component: AddModuleAssessmentComponent, data: { title: "rail e-learning Admin | Add Module" } }
    ],
    data: { title: "rail e-learning Admin | Add Module" }
  },{
    path: "add_authoring_assessment",
    component: AdminComponent,
    children: [
      { path: "", component: AddAuthoringAssessmentComponent, data: { title: "rail e-learning Admin | Add Authoring Assessment" } }
    ],
    data: { title: "rail e-learning Admin | Add Authoring Assessment" }
  },{
    path: "authoring_list",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringListComponent, data: { title: "rail e-learning Admin | Authoring Create" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Create" }
  },{
    path: "authoring_create",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringCreateComponent, data: { title: "rail e-learning Admin | Authoring Create" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Create" }
  },{
    path: "authoring_view",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringViewComponent, data: { title: "rail e-learning Admin | Authoring View" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Create" }
    
  },{
    path: "authoring_assessment_view",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringAssessmentViewComponent, data: { title: "rail e-learning Admin | Authoring Create" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Create" }
  },{
    path: "course_assessment_view",
    component: AdminComponent,
    children: [
      { path: "", component: CourseAssessmentViewComponent, data: { title: "rail e-learning Admin | Authoring Create" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Create" }
  },{
    path: "authoring_avtivated",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringActivatedCourseComponent, data: { title: "rail e-learning Admin | Authoring Avtivated" } }
    ],
    data: { title: "rail e-learning Admin | Authoring Avtivated" }
  },{
    path: "authoring_deavtivated",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringDeactivatedCourseComponent, data: { title: "rail e-learning Admin | Authoring de-Avtivated" } }
    ],
    data: { title: "rail e-learning Admin | Authoring de-Avtivated" }
  },{
    path: "authoring_viewContent",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringViewContentComponent, data: { title: "rail e-learning Admin | Authoring de-Avtivated" } }
    ],
    data: { title: "rail e-learning Admin | Authoring de-Avtivated" }
  },{
    path: "reset",
    component: AdminComponent,
    children: [
      { path: "", component: ResetComponent, data: { title: "rail e-learning Admin | Reset" } }
    ],
    data: { title: "rail e-learning Admin | Reset" }
  },
  {
    path: "organization_successfully",
    component: AdminComponent,
    children: [
      { path: "", component: OrganizationSuccessfullyComponent, data: { title: "rail e-learning Admin | User Successfully" } }
    ],
    data: { title: "rail e-learning Admin | Organization Successfully" }
  },
  {
    path: "super-admin",
    component: AdminComponent,
    children: [
      { path: "", component: SuperAdminComponent, data: { title: "rail e-learning Admin | super-admin" } }
    ],
    data: { title: "rail e-learning Admin | super-admin" }
  },    
  {
    path: "super-admin-create",
    component: AdminComponent,
    children: [
      { path: "", component: SuperAdminCreateComponent, data: { title: "rail e-learning Admin | super-admin-create" } }
    ],
    data: { title: "rail e-learning Admin | super-admin-create" }
  } ,
  {
    path: "super-admin-edit",
    component: AdminComponent,
    children: [
      { path: "", component: SuperAdminEditComponent, data: { title: "rail e-learning Admin | super-admin-edit" } }
    ],
    data: { title: "rail e-learning Admin | super-admin-edit" }
  },
  // {
  //   path: "forgot-password",
  //   component: AdminComponent,
  //   children: [
  //     { path: "", component: AdminForgotPasswordComponent, data: { title: "rail e-learning Admin | admin-forgot-password" } }
  //   ],
  //   data: { title: "rail e-learning Admin | admin-forgot-password" }
  // } 
  {
    path: "forgot-password",
    component: AdminForgotPasswordComponent,
    data: { title: "rail e-learning | Admin Forgot Password" }
  },
  {
    path: "course-details",
    component: AdminComponent,
    children: [
      { path: "", component: CourseDetailsComponent, data: { title: "rail e-learning Admin | course-details" } }
    ],
    data: { title: "rail e-learning Admin | course-details" }
  },
  
  {
    path: "reports",
    component: AdminComponent,
    children: [
      { path: "", component: ReportsComponent, data: { title: "rail e-learning Admin | reports" } }
    ],
    data: { title: "rail e-learning Admin | reports" }
  }, 
  
  {
    path: "setting",
    component: AdminComponent,
    children: [
      { path: "", component: SettingComponent, data: { title: "rail e-learning Admin | setting" } }
    ],
    data: { title: "rail e-learning Admin | setting" }
  }, 
  {
    path: "assigned-reset-request",
    component: AdminComponent,
    children: [
      { path: "", component: AssignedResetRequestComponent, data: { title: "rail e-learning Admin | assigned-reset-request" } }
    ],
    data: { title: "rail e-learning Admin | assigned-reset-request" }
  } 
  ,     
  {
    path: "authoring-deactivated-course",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringDeactivatedCourseComponent, data: { title: "rail e-learning Admin | authoring-deactivated-course" } }
    ],
    data: { title: "rail e-learning Admin | authoring-deactivated-course" }
  },    
  {
    path: "authoring-activated-course",
    component: AdminComponent,
    children: [
      { path: "", component: AuthoringActivatedCourseComponent, data: { title: "rail e-learning Admin | authoring-activated-course" } }
    ],
    data: { title: "rail e-learning Admin | authoring-activated-course" }
  },
  {
    path: "manage-tickets",
    component: AdminComponent,
    children: [
      { path: "", component: ManageTicketsComponent, data: { title: "rail e-learning Admin | manage-tickets" } }
    ],
    data: { title: "rail e-learning Admin | Manage Ticket" }
  },    
  {
    path: "ticket-detail",
    component: AdminComponent,
    children: [
      { path: "", component: TicketDetailComponent, data: { title: "rail e-learning Admin | ticket-detail" } }
    ],
    data: { title: "rail e-learning Admin | Ticket Detail" }
  },   
  {
    path: "manage-assessments",
    component: AdminComponent,
    children: [
      { path: "", component: ManageAssessmentsComponent, data: { title: "rail e-learning Admin | manage-assessments" } }
    ],
    data: { title: "rail e-learning Admin | Manage Assessments" }
  },    
  {
    path: "create-assessment",
    component: AdminComponent,
    children: [
      { path: "", component: CreateAssessmentComponent, data: { title: "rail e-learning Admin | create-assessment" } }
    ],
    data: { title: "rail e-learning Admin | Create Assessment" }
  },     
  {
    path: "view-assessment",
    component: AdminComponent,
    children: [
      { path: "", component: ViewAssessmentComponent, data: { title: "rail e-learning Admin | view-assessment" } }
    ],
    data: { title: "rail e-learning Admin | View Assessment" }
  },  
  {
    path: "assign-users",
    component: AdminComponent,
    children: [
      { path: "", component: AssessmentAssignUsersComponent, data: { title: "rail e-learning Admin | assessment-assign-users" } }
    ],
    data: { title: "rail e-learning Admin | Assessment Assign User" }
  },  
  {
    path: "view-user",
    component: AdminComponent,
    children: [
      { path: "", component: AssessmentViewUserComponent, data: { title: "rail e-learning Admin | assessment-view-user" } }
    ],
    data: { title: "rail e-learning Admin | Assessment View User" }
  },  
  {
    path: "viewer-assessment",
    component: LayoutComponent,
    children: [
      { path: "", component: ViewerAssessmentComponent, data: { title: "rail e-learning Admin | viewer-assessment" } }
    ],
    data: { title: "rail e-learning Admin | Viewer Assessment" }
  },  
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
 
 
